import { apiFetch } from './prospects.js';

export async function fetchWebCreatorSites() {
  return apiFetch('/web-creator/sites');
}

export async function fetchWebCreatorSite(id) {
  return apiFetch(`/web-creator/sites/${id}`);
}

export async function fetchWebCreatorPublic(slug) {
  const PUBLIC_API = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1/api';
  const token =
    typeof localStorage !== 'undefined' ? localStorage.getItem('authToken') : '';
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(
    `${PUBLIC_API}/web-creator/public/${encodeURIComponent(slug)}`,
    { headers },
  );
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(body?.data?.message || 'Page introuvable.');
  }
  return body;
}

export async function createWebCreatorClickCollectOrder(slug, payload) {
  const PUBLIC_API = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1/api';
  const res = await fetch(
    `${PUBLIC_API}/web-creator/public/${encodeURIComponent(slug)}/click-collect-order`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
  const data = await res.json().catch(() => null);
  if (!res.ok || !data?.success) {
    throw new Error(data?.data?.message || 'Commande impossible.');
  }
  return data;
}

export async function createWebCreatorReservationRequest(slug, payload) {
  const PUBLIC_API = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1/api';
  const res = await fetch(
    `${PUBLIC_API}/web-creator/public/${encodeURIComponent(slug)}/reservation-request`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
  const data = await res.json().catch(() => null);
  if (!res.ok || !data?.success) {
    throw new Error(data?.data?.message || 'Demande impossible.');
  }
  return data;
}

export async function createWebCreatorSite(payload) {
  return apiFetch('/web-creator/sites', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateWebCreatorSite(id, payload) {
  return apiFetch(`/web-creator/sites/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export async function uploadWebCreatorSiteMedia(siteId, file) {
  const fd = new FormData();
  fd.append('file', file);
  return apiFetch(`/web-creator/sites/${siteId}/media`, {
    method: 'POST',
    body: fd,
  });
}

export async function repairWebCreatorInlineAssets(siteId) {
  return apiFetch(`/web-creator/sites/${siteId}/repair-inline-assets`, {
    method: 'POST',
  });
}

export async function deleteWebCreatorSite(id) {
  return apiFetch(`/web-creator/sites/${id}`, { method: 'DELETE' });
}

export async function fetchWebCreatorTemplates() {
  return apiFetch('/web-creator/templates');
}

export async function fetchWebCreatorTemplate(id) {
  return apiFetch(`/web-creator/templates/${id}`);
}

export async function createWebCreatorTemplate(payload) {
  return apiFetch('/web-creator/templates', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function cloneWebCreatorTemplate(id, payload = {}) {
  return apiFetch(`/web-creator/templates/${id}/clone`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

/** Génère (ou réutilise) le QR premium HubUP côté serveur. */
export async function generateWebCreatorHubupQr(payload) {
  return apiFetch('/web-creator/hubup-qr/generate', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function deleteWebCreatorTemplate(id) {
  return apiFetch(`/web-creator/templates/${id}`, { method: 'DELETE' });
}

export function buildWebCreatorPublicUrl(slug) {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/lp/${encodeURIComponent(slug)}`;
  }
  return `/lp/${encodeURIComponent(slug)}`;
}

const PUBLIC_API = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1/api';

export async function createWebCreatorProductCheckout(slug, body) {
  const res = await fetch(
    `${PUBLIC_API}/web-creator/public/${encodeURIComponent(slug)}/product-checkout`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
  const data = await res.json().catch(() => null);
  if (!res.ok && !data?.success) {
    throw new Error(data?.data?.message || 'Erreur de paiement.');
  }
  return data;
}

export async function confirmWebCreatorProductCheckout(body) {
  const res = await fetch(`${PUBLIC_API}/web-creator/public/product-checkout/confirm`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok && !data?.success) {
    throw new Error(data?.data?.message || 'Confirmation impossible.');
  }
  return data;
}
